import { useState, useEffect } from 'react';
import { apiURL1 } from '../config';


export const useFetchAttendance = (userId, filterDate, filterStatus) => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    const token = localStorage.getItem("token");


    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                let url = `${apiURL1}/student/${userId}/attendance`;
                const params = new URLSearchParams();
                if (filterDate) {
                    params.append('date', filterDate);
                }
                if (filterStatus) {
                    params.append('status', filterStatus);
                }
                const queryString = params.toString();
                if (queryString) {
                    url += `?${queryString}`;
                }
                const response = await fetch(url, {
                    method: 'GET', // or any other HTTP method as needed
                    headers: {
                        'Authorization': `Bearer ${token}`, // Add token to headers
                        // Any other headers can go here
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                const result = await response.json();
                setData(result);
            } catch (err) {
                setError(err);
            } finally {
                setIsLoading(false);
            }
        };

        if (userId) {
            fetchData();
        }
    }, [userId, filterDate, filterStatus]);

    return { isLoading, data, error };
};